module.exports = __webpack_public_path__ + "img/گوشه-نرم.06d584ad.jpg";